<template>
  <div class="pie">
    <!-- <div class="wordtext">
      <p class="percent">{{hoverData.name}}</p>
    
    </div> -->
    <v-chart :options="pie" id="echart4" auto-resize></v-chart>
    <div
      class="no-chart-data"
      style="color:#D3D3D3;font-size:20px;"
      v-show="isNopie"
    >Temporarily no data</div>
  </div>
</template>

<script>
let setOption = () => {
  // let barColor = ["#FF9F7F", "#FFDB5C", "#E7BCF3", "#E062AE", "#9084FF", "#FF9F7F", "#37A2DA"];
  let barColor = [
    {
      name: "Positive",
      color: "#5C89FF"
    },
    {
      name: "Partial positive",
      color: "#7C6AF2"
    },
    {
      name: "Neutral",
      color: "#C95FF2"
    },
    {
      name: "Partial negative",
      color: "#FF6383"
    },
    {
      name: "Negative",
      color: "#FF9F40"
    }
  ];
  let result = [];
  for (let i = 0; i < barColor.length; i++) {
    result.push({
      type: "bar",
      name: barColor[i].name,
      itemStyle: {
        normal: {
          color: barColor[i].color
        }
      }
    });
  }
  return result;
};

let pieShow = [
  ["35%", "55%"],
  [0, 100]
];

export default {
  // props: ["echartsData", "pieName"],
  props: {
    echartsData: {},
    pieName: {},
    getSolid: {
      default: true
    },
    isNopie: {},
    hoverData: {}
  },
  name: "pie",
  mounted() {
    this.setOptions();
    window.addEventListener("resize", () => {
      this.myChart4.resize();
    });
  },
  data() {
    return {
      pie: {},
      myChart4: ""
    };
  },
  methods: {
    setOptions() {
      let echarts = require("echarts");
      let newResultData = this.$lodash.cloneDeep(this.echartsData);
      if (newResultData.length > 0) {
        newResultData.map((item, index) => {
          //循环对应颜色
          setOption().map((optionItem, optionIndex) => {
            if (item.name === setOption()[optionIndex].name) {
              item = Object.assign(item, setOption()[optionIndex]);
            }
          });
        });
        this.pie = this.getOptions(newResultData, this.pieName, this.getSolid);
      } else {
        this.pie = this.getOptions(newResultData, this.pieName, this.getSolid);
      }
      this.myChart4 = echarts.init(document.getElementById("echart4"));
    },
    getOptions(resultpieData, pieName, isSolid) {
      return {
        toolbox: {
          //工具栏(下载)
          feature: {
            saveAsImage: {
              show: true,
              title: "Save as picture"
            }
          },
          right: "5%"
        },
        // title: {
        //     show: this.echartsData.length === 0,
        //     textStyle: {
        //         color: "LightGrey",
        //         fontSize: 20
        //     },
        //     text: "Temporarily no data",
        //     left: "center",
        //     top: "center"
        // },
        title: {
          text: "Emotion Distribution Pie Chart",
          show: false
        },
        graphic:{
          type:"text",
          left:"center",
          // top:"50%",
          style:{
              text:this.pieName,
              textAlign:"center",
              fill:"#333",
              fontSize:18,
              fontFamily: 'RCB'
          }
        },
        tooltip: {
          trigger: "item",
          formatter: function(parms) {
            var str =
              parms.marker +
              "" +
              parms.data.name +
              "</br>" +
              "Quantity: " +
              parms.data.value +
              "</br>" +
              "Proportion: " +
              parms.percent +
              "%";
            return str;
          }
        },
        grid: {
          top: "5%",
          left: "0%",
          right: "3%",
          bottom: "3%",
          containLabel: true
        },
        legend: {
          //type: "scroll",
          type: "plain",
          orient: "horizontal", // horizontal     vertical
          icon: "circle", // circle  //roundRect
          // itemWidth && itemHeight 同时设置更改大小
          itemWidth: 9,
          itemHeight: 9,
          itemGap: 10,
          // left: "auto",
          // align: "left",
          bottom: 0,
          textStyle: {
            color: "#8C8C8C",
            fontSize: 12
          },
          height: 100,
          data: this.pieName
        },
        series: [
          {
            name: "",
            type: "pie",
            center: ["50%", "42%"],
            // 饼图大小
            radius: isSolid == true ? pieShow[0] : pieShow[1],
            //饼图的扇区是否是顺时针排布
            clockwise: false,
            //视觉引导线 标签
            label: {
              normal: {
                show: true,
                position: "outter",
                // formatter: `{b}{hr|}\n{d}%`,
                fontFamily: 'RCR',
                padding: [0, -15],
                borderWidth: 40,
                borderRadius: 2,
                rich: {
                  hr: {
                    // borderColor: "#12EABE",
                    width: "100%",
                    borderWidth: 1,
                    height: 3
                  }
                },
                formatter(v) {
                  let text = v.name + " " +Math.round(v.percent) + "%";
                  // if (!text) return "";
                  // if (text.length > 5) {
                  //   return text.slice(0, 30) + "...";
                  // }
                  if(text.length <= 8)
                  {
                      return text;
                  }else if(text.length > 8){
                      return text = `${text.slice(0,8)}\n${text.slice(8,30)}\n${text.slice(30)}`
                  }
                  
                }
              }
            },
            avoidLabelOverlap: true, //是否启用防止标签重叠策略
            // 视觉引导线
            labelLine: {
              normal: {
                show: true,
                length: 30,
                length2: 10,
                smooth: false
              }
            },
            data: resultpieData
          }
        ]
      };
    }
  },
  watch: {
    getSolid(val) {},
    echartsData() {
      this.setOptions();
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 100%;
}
.pie {
  position: relative;
}
.pie .no-chart-data {
  width: 300px;
  font-size: 25;
  font-weight: 600;
  position: absolute;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -588%);
}
.pie .wordtext {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-10%, 50%);
  z-index: 999;
  font-size: 20px;
  width: 100px;
  height: 20px;
  white-space:normal;
}
</style>
